// SCRIPT GLOBAL POUR LES TAXES D'ACCISE TECNOVA
window.TecnovaTaxes = (function () {
  const txPrices = {
    "TXP1": 1.12, "TXP2": 2.24, "TXP3": 3.36, "TXP4": 4.48, "TXP5": 5.60,
    "TXP6": 6.72, "TXP7": 7.84, "TXP8": 8.96, "TXP9": 10.08, "TXP10": 11.20,
    "TXP11": 12.32, "TXP12": 13.44, "TXP13": 14.56, "TXP14": 15.68, "TXP15": 16.80,
    "TXP16": 17.92, "TXF1": 1.12, "TXF2": 2.24, "TXF3": 3.36, "TXF4": 4.48, "TXF5": 5.60,
    "TXF6": 6.72, "TXF7": 7.84, "TXF8": 8.96, "TXF9": 10.08, "TXF10": 11.20,
    "TXF11": 12.32, "TXF12": 13.44, "TXF13": 14.56, "TXF14": 15.68, "TXF15": 16.80,
    "TXF16": 17.92,
  };

  function getTaxTags(sku) {
    /* console.log("TecnovaTaxes getTaxTags"); */
    const txpTag = sku.match(/TXP\d+/) ? sku.match(/TXP\d+/)[0] : null;
    const txfTag = sku.match(/TXF\d+/) ? sku.match(/TXF\d+/)[0] : null;
    return { txpTag, txfTag };
  }

  function calculateAndUpdateTaxes(productElement) {
    const unitPriceElement = productElement.querySelector('.unit-price');
    const unitPrice = parseFloat(unitPriceElement.innerText.replace(/[$,]/g, '')) || 0;

    const isUsMarket = window.theme?.currentMarketHandle === 'united';
    const sku = productElement.querySelector('.product-sku').value;
    const { txpTag, txfTag } = getTaxTags(sku);
    const excise = (txPrices[txpTag] || 0) + (txPrices[txfTag] || 0);

    if (isUsMarket) {
      const duty = (unitPrice + excise) * 0.35;
      const taxExciseEl = productElement.querySelector('.tax-excise');
      if (taxExciseEl) taxExciseEl.innerText = `$${excise.toFixed(2)}`;
      productElement.querySelector('.tax-fed').innerText = `$${duty.toFixed(2)}`;
      productElement.querySelector('.total-price').innerText = `$${(unitPrice + excise + duty).toFixed(2)}`;
    } else {
      productElement.querySelector('.tax-fed').innerText = `$${excise.toFixed(2)}`;
      productElement.querySelector('.total-price').innerText = `$${(unitPrice + excise).toFixed(2)}`;
    }
  }

  function initTaxCalculationForHoveredProduct(tooltipElement) {
    /* console.log("TecnovaTaxes initTaxCalculationForHoveredProduct"); */
    const productElement = tooltipElement.closest('.price__container') || tooltipElement.closest('.price-container');
    if (productElement) {
      calculateAndUpdateTaxes(productElement);
    }
  }

  return {
    initTaxCalculationForHoveredProduct
  };
})();


// Fonction pour mettre à jour la progression du "free shipping"
// function updateFreeShippingProgress(grandTotal) {
//   // Valeur minimum requise pour la livraison gratuite (doit être définie quelque part dans votre code)
//   const freeShippingMinimum = 50; // Exemple, remplacez cette valeur par la valeur réelle

//   // Calculer le pourcentage de progression
//   const progressPercentage = Math.min((grandTotal / freeShippingMinimum) * 100, 100);

//   // Mettre à jour la barre de progression
//   const progressBar = document.querySelector('.free-shipping-notice__bar');
//   if (progressBar) {
//     progressBar.style.setProperty('--progress', `${progressPercentage}%`);
//   }

//   // Mettre à jour le texte de la livraison gratuite
//   const freeShippingTextElement = document.querySelector('.free-shipping-notice__heading');
//   const storeLocale = Shopify.locale;
  
//   if (freeShippingTextElement) {
//     if (grandTotal >= freeShippingMinimum) {
//       if (storeLocale === 'fr') {
//         freeShippingTextElement.innerHTML = '<strong>Livraison gratuite obtenue !</strong>';
//       } else {
//         freeShippingTextElement.innerHTML = '<strong>Free shipping unlocked!</strong>';
//       }
//     } else {
//       const remainingAmount = freeShippingMinimum - grandTotal;
//       const formattedRemainingAmount = formatCurrency(remainingAmount);
//       if (storeLocale === 'fr') {
//         freeShippingTextElement.innerHTML = `Il vous manque ${formattedRemainingAmount} pour obtenir la livraison gratuite.`;
//       } else {
//         freeShippingTextElement.innerHTML = `You are ${formattedRemainingAmount} away from free shipping.`;
//       }
//     }
//   }
// }


/* FONCTION POUR CALCULER LE TOTAL */
function formatCurrency(amount) {
  return `$${amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
}

function calculateGrandTotal() {
  let grandTotal = 0;
  let totalAcciseFed = 0;

  const formatter = new Intl.NumberFormat('fr-CA', {
    style: 'currency',
    currency: 'CAD'
  });

  // Parcourir chaque ligne du panier
  document.querySelectorAll('.item-panier').forEach(cartItem => {
    const quantity = parseInt(cartItem.querySelector('.qty-input__input').value, 10) || 1;
    const unitPrice = parseFloat(cartItem.dataset.unitPrice.replace(',', '.')) || 0;

    // Vérifie si l'élément .tax-fed existe avant de lire sa valeur
    const taxFedElement = cartItem.querySelector('.tax-fed');
    const taxFed = taxFedElement ? parseFloat(taxFedElement.innerText.replace('$', '')) || 0 : 0;

    // Calcul du total de la ligne avec les taxes
    const lineTotal = (unitPrice * quantity) - taxFed;
    totalAcciseFed += taxFed;
    grandTotal += lineTotal;

    // Exclure la protection d'expédition (produit défini dans les réglages du thème) du grand total
    const variantId = cartItem.dataset.variantId;
    const shippingProtectionVariantId = String(window.theme?.settings?.shippingProtectionVariantId || '');
    if (shippingProtectionVariantId && variantId === shippingProtectionVariantId) {
      grandTotal -= unitPrice * quantity;
    }
  });

  // Afficher le total de l'accise dans le conteneur
/*   const totalAcciseContainer = document.querySelector('.amount-excise-total');
  if (totalAcciseContainer) {
        console.log("[125] totalAccise :", totalAcciseFed);
    totalAcciseContainer.innerText = `$${totalAcciseFed.toFixed(2)}`;
  } */

  return grandTotal; 
}




// FONCTION POUR CALCULER LA TAXE AU PANIER
// Script global pour gérer les taxes dans le panier
window.TecnovaCartTaxes = (function () {
      let totalAcciseFed = 0;
  const txPrices = {
    "TXP1": 1.12, "TXP2": 2.24, "TXP3": 3.36, "TXP4": 4.48, "TXP5": 5.60,
    "TXP6": 6.72, "TXP7": 7.84, "TXP8": 8.96, "TXP9": 10.08, "TXP10": 11.20,
    "TXP11": 12.32, "TXP12": 13.44, "TXP13": 14.56, "TXP14": 15.68, "TXP15": 16.80,
    "TXP16": 17.92, "TXF1": 1.12, "TXF2": 2.24, "TXF3": 3.36, "TXF4": 4.48, "TXF5": 5.60,
    "TXF6": 6.72, "TXF7": 7.84, "TXF8": 8.96, "TXF9": 10.08, "TXF10": 11.20,
    "TXF11": 12.32, "TXF12": 13.44, "TXF13": 14.56, "TXF14": 15.68, "TXF15": 16.80,
    "TXF16": 17.92,
  };
    

  // Fonction pour extraire les balises TXP et TXF depuis le SKU
  function getTaxTags(sku) {
    /* console.log("TecnovaCartTaxes getTaxTags"); */
    const txpTag = sku.match(/TXP\d+/) ? sku.match(/TXP\d+/)[0] : null;
    const txfTag = sku.match(/TXF\d+/) ? sku.match(/TXF\d+/)[0] : null;
    return { txpTag, txfTag };
  }

  // Calcul des taxes et mise à jour du total pour un élément du panier
  function calculateAndUpdateTaxesForCartItem(cartItem) {

    /* console.log("TecnovaCartTaxes calculateAndUpdateTaxesForCartItem"); */
    const sku = cartItem.dataset.sku;
    const quantityInput = cartItem.querySelector('.qty-input__input');

    if (!quantityInput) {
      console.error(`Élément '.quantity__input' introuvable pour l'élément ${sku}.`);
      return;
    }

    const quantity = parseInt(quantityInput.value, 10) || 1;
    const { txpTag, txfTag } = getTaxTags(sku);

    const txpValue = txPrices[txpTag] || 0;
    const txfValue = txPrices[txfTag] || 0;

    const unitPrice = parseFloat(cartItem.dataset.unitPrice.replace(',', '.')) || 0;
    const totalTaxesPerItem = txfValue + txpValue; 
    const totalTaxes = totalTaxesPerItem * quantity;
    const totalPrice = (unitPrice + totalTaxesPerItem) * quantity;
    totalAcciseFed += totalTaxes;

    /* console.log(`SKU: ${sku}`);
    console.log(`Total Taxes: ${totalTaxes}, Total Price: ${totalPrice}`); */

    const taxFedElement = cartItem.querySelector('.tax-fed');
    const taxProvElement = cartItem.querySelector('.tax-prov');
    const totalPriceElement = cartItem.querySelector('.total-price');
    const unitTotalPrice = cartItem.querySelector('.unit-price-total');
    
    const totalAccise = document.querySelector('.amount-excise-total');
    /* console.log("[187] totalAcciseFed :", totalAcciseFed); */

    if(totalAccise) totalAccise.innerText = `$${totalAcciseFed.toFixed(2)}`;
    if (taxFedElement) taxFedElement.innerText = ` $${(totalTaxesPerItem * quantity).toFixed(2)}`;
    if (taxProvElement) taxProvElement.innerText = ` $${(txpValue * quantity).toFixed(2)}`;
    if (totalPriceElement) totalPriceElement.innerText = ` $${totalPrice.toFixed(2)}`;
    if (unitTotalPrice) unitTotalPrice.innerText = `$${(unitPrice * quantity).toFixed(2)}`;
  }

  // Mise à jour des taxes et des totaux pour tous les items du panier
  function updateTaxesForAllCartItems() {
    /* console.log("TecnovaCartTaxes updateTaxesForAllCartItems"); */
    totalAcciseFed = 0;

    const isMarketTax = window.theme?.settings?.marketTaxesHandle
      && window.theme?.currentMarketHandle === window.theme?.settings?.marketTaxesHandle;

    if (isMarketTax) {
      let totalExcise = 0;
      document.querySelectorAll('.item-panier:not([data-market-tax]):not([data-tax-for])').forEach(function(cartItem) {
        const sku = cartItem.dataset.sku || '';
        const quantity = parseInt(cartItem.querySelector('.qty-input__input')?.value, 10) || 1;
        const { txpTag, txfTag } = getTaxTags(sku);
        totalExcise += ((txPrices[txpTag] || 0) + (txPrices[txfTag] || 0)) * quantity;
      });
      const marketTaxItem = document.querySelector('.item-panier[data-market-tax]');
      if (marketTaxItem) {
        const qty = parseInt(marketTaxItem.querySelector('.qty-input__input')?.value, 10) || 1;
        const unitPrice = parseFloat(marketTaxItem.dataset.unitPrice.replace(',', '.')) || 0;
        totalAcciseFed = totalExcise + unitPrice * qty;
      } else {
        totalAcciseFed = totalExcise;
      }
      const totalAccise = document.querySelector('.amount-excise-total');
      if (totalAccise) totalAccise.innerText = `$${totalAcciseFed.toFixed(2)}`;
      return;
    }

    const cartItems = document.querySelectorAll('.item-panier');
    cartItems.forEach(calculateAndUpdateTaxesForCartItem);

    // const grandTotal = calculateGrandTotal();
    // updateFreeShippingProgress(grandTotal);
  }
  

  // Gestion du changement de quantité
  function handleQuantityChange() {
    console.log("TecnovaCartTaxes handleQuantityChange");
    const quantityInputs = document.querySelectorAll('.qty-input__input');

    quantityInputs.forEach(input => {
      input.addEventListener('input', updateTaxesForAllCartItems); // Réagit immédiatement au changement
      input.addEventListener('change', updateTaxesForAllCartItems); // Réagit lorsque l'utilisateur quitte le champ
    });
  }

  // Initialisation du script
  function init() {
    updateTaxesForAllCartItems();
    handleQuantityChange(); // Attache les écouteurs d'événements
  }

  return {
    init,
    updateTaxesForAllCartItems
  };
})();

/**
 * JAVASCRIPT DEVELOPER DOCUMENTATION
 *
 * Enterprise is a powerful and customizable theme designed for large-scale e-commerce stores. Built
 * using Web Components, it offers a highly modular architecture that makes customization and
 * maintenance easier than ever. In addition, Enterprise is optimized for speed, ensuring that your
 * store runs as fast as possible to provide your customers with a seamless shopping experience.
 *
 * If you would like to add your own JS to Enterprise, we recommend using this file and referencing
 * it using Theme Settings > Advanced > Custom HTML.
 *
 * As a brief overview, Enterprise:
 *  - Broadcasts many JS events.
 *  - Is built using Web Components.
 *  - Follows a 'code splitting' architecture.
 *  - Is completely custom built (no JS libraries other than instant.page)
 *  - Has a number of JS utilities.
 *
 *
 *
 * =================================================================================================
 * Custom JavaScript Events
 * =================================================================================================
 *
 * Enterprise broadcasts many custom events for ease of extensibility, detailed in this section.
 *
 * When in the Theme Editor, the details of each custom event will be logged out in the Dev Tools
 * console everytime it is triggered.
 *
 * Events are named in the following convention: ["on/dispatch"]:[subject]:[action] (where
 * 'dispatch' will trigger an event to occur, and 'on' indicates an event has occurred).
 *
 * All 'Return data' detailed in this section is returned within the 'event.detail' object.
 *
 * The available events are:
 *  1.  on:variant:change
 *  2.  on:cart:add
 *  3.  on:cart:error
 *  4.  on:line-item:change
 *  5.  on:cart-drawer:before-open
 *  6.  on:cart-drawer:after-open
 *  7.  on:cart-drawer:after-close
 *  8.  on:quickbuy:before-open
 *  9.  on:quickbuy:after-open
 *  10. on:quickbuy:after-close
 *  11. dispatch:cart-drawer:open
 *  12. dispatch:cart-drawer:refresh
 *  13. dispatch:cart-drawer:close
 *  14. on:debounced-resize
 *  15. on:breakpoint-change
 *
 * -------------------------------------------------------------------------------------------------
 * 1) on:variant:change
 * -------------------------------------------------------------------------------------------------
 * Fires whenever a variant is selected (e.g. Product page, Quickbuy, Featured Product etc).
 *
 * How to listen:
 * document.addEventListener('on:variant:change', (event) => {
 *  // your code here
 * });
 *
 * Returned data:
 *  - form: the product form content
 *  - variant: the selected variant object
 *  - product: the product object (includes a list of all variants)
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 2) on:cart:add
 * -------------------------------------------------------------------------------------------------
 * Fires when a variant has been added to the cart, where it didn't exist in the cart before. This
 * event does not fire when the added variant was already in the cart. To listen for this, see the
 * on:line-item:change event.
 *
 * How to listen:
 * document.addEventListener('on:cart:add', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - cart: the new cart object after the variant was added
 *   - variantId: id of the variant that was just added to the cart
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 3) on:line-item:change
 * -------------------------------------------------------------------------------------------------
 * Fires when the quantity of an item already in the cart is updated. Note, if the 'newQuantity' is
 * 0, this indicates the item was removed from that cart.
 *
 * Note, when adding a variant to the cart - this event will fire if that variant is already in the
 * cart (i.e. the quantity is incremented). In this situation, 'on:cart:add' will not fire.
 *
 * How to listen:
 * document.addEventListener('on:line-item:change', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - cart: the new cart object after the quantity change was completed
 *   - variantId: id of the variant that was just updated
 *   - newQuantity: new quantity of the line item
 *   - oldQuantity: old quantity of the line item
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 4) on:cart:error
 * -------------------------------------------------------------------------------------------------
 * Fires when an action related to the cart has failed, for example adding too much quantity of an
 * item to the cart.
 *
 * How to listen:
 * document.addEventListener('on:cart:error', (event) => {
 *   // your code here
 * });
 *
 * Returned data:
 *   - error: the error message
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 5) on:cart-drawer:before-open
 * -------------------------------------------------------------------------------------------------
 * Fires before the cart drawer opens.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:before-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 6) on:cart-drawer:after-open
 * -------------------------------------------------------------------------------------------------
 * Fires after the cart drawer has finished opening.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:after-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 7) on:cart-drawer:after-close
 * -------------------------------------------------------------------------------------------------
 * Fires after the cart drawer has finished closing.
 *
 * How to listen:
 * document.addEventListener('on:cart-drawer:after-close', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 8) on:quickbuy:before-open
 * -------------------------------------------------------------------------------------------------
 * Fires before the quick buy drawer opens.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:before-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 9) on:quickbuy:after-open
 * -------------------------------------------------------------------------------------------------
 * Fires after the quick buy drawer has finished opening.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:after-open', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 10) on:quickbuy:after-close
 * -------------------------------------------------------------------------------------------------
 * Fires after the quick buy drawer has finished closing.
 *
 * How to listen:
 * document.addEventListener('on:quickbuy:after-close', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 11) dispatch:cart-drawer:open
 * -------------------------------------------------------------------------------------------------
 * Opens the cart drawer (if enabled in the Theme Settings).
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
 *
 * You can optionally pass in a 'detail' object with a property of 'opener', which specifies the DOM
 * element that should be focussed on when the drawer is closed.
 *
 * Example:
 * document.getElementById('header-search').addEventListener('keydown', (evt) => {
 *   if (evt.keyCode === 67) {
 *     evt.preventDefault();
 *     document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
 *       detail: {
 *         opener: evt.target
 *       }
 *     }));
 *   }
 * });
 *
 * In this example, we attach a keydown listener to the search input in the header. If the user
 * presses the 'c' key, it prevents the default behavior (which would be to type the letter 'c' in
 * the input) and dispatches the 'dispatch:cart-drawer:open' event with a 'detail' object that
 * specifies the search input as the opener. When the cart drawer is closed, focus is returned to
 * the search input.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 12) dispatch:cart-drawer:refresh
 * -------------------------------------------------------------------------------------------------
 * Refreshes the contents of the cart drawer.
 *
 * This event is useful when you are adding variants to the cart and would like to instruct the
 * theme to re-render the cart drawer.
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
 *   bubbles: true
 * }));
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 13) dispatch:cart-drawer:close
 * -------------------------------------------------------------------------------------------------
 * Closes the cart drawer.
 *
 * How to trigger:
 * document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:close'));
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 14) on:debounced-resize
 * -------------------------------------------------------------------------------------------------
 * Fires when the viewport finishes resizing (debounced to 300ms by default).
 *
 * How to listen:
 * window.addEventListener('on:debounced-resize', (event) => {
 *   // your code here
 * });
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 15) on:breakpoint-change
 * -------------------------------------------------------------------------------------------------
 * Fires when the breakpoint of the viewport changes. See the 'Media Queries' section in this file
 * for more.
 *
 * Example:
 * window.addEventListener('on:breakpoint-change', (event) => {
 *  if (theme.mediaMatches.md) {
 *   console.log('we are not on mobile');
 *  }
 * });
 *
 *
 *
 * =================================================================================================
 * Web Components
 * =================================================================================================
 *
 * Enterprise utilizes Web Components to the fullest.
 *
 * Web Components are a set of standardized APIs that allow developers to create custom, reusable
 * HTML elements that can be used across different web pages and applications.
 * Web Components consist of three main technologies: Custom Elements, Shadow DOM and HTML
 * Templates.
 *
 * See Mozilla for more: https://developer.mozilla.org/en-US/docs/Web/Web_Components
 *
 *
 *
 * =================================================================================================
 * Third-Party JavaScript Dependencies
 * =================================================================================================
 *
 * Enterprise only has one third-party dependency: instant.page (https://instant.page/).
 *
 * It's included locally and is only active if it has been enabled in
 * 'Theme Settings > Advanced > Preload links on hover'.
 *
 * Instant.page is a JavaScript library that speeds up page loads by preloading links as soon as the
 * customer hovers over them.
 *
 *
 *
 * =================================================================================================
 * Code Splitting
 * =================================================================================================
 * We followed the ‘code splitting’ technique when building Enterprise.
 *
 * Code splitting consists in writing JavaScript (and CSS)in a modularized way within typically
 * small, more manageable files that can be loaded on-demand, as needed. The idea is to improve the
 * performance of our theme by reducing the amount of code that needs to be loaded upfront.
 *
 * If the customer is visiting a specific page of the theme that requires certain JavaScript
 * functionality, only the code needed for that page will be loaded, rather than one large
 * JavaScript file containing largely unused code. For example, the file media-gallery.js will
 * only be loaded if there is a media gallery on the page.
 *
 * Shopify uses HTTP/2, which is the newer version of the HTTP protocol used to deliver web content.
 * HTTP/2 supports multiplexing, which means that multiple requests can be sent over a single
 * connection at the same time - meaning multiple JS files are essentially served at the speed of a
 * single file.
 *
 * The only JS file which is served on every page in Enterprise is 'main.js'. Main.js contains
 * utility JS which is likely to be needed by many scripts. This is outlined more in the next
 * section.
 *
 *
 *
 * =================================================================================================
 * Utilities
 * =================================================================================================
 * Enterprise provides a few utility utilities, contained in main.js. Some of the key ones are
 * outlined below. See main.js for more.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 1) Lazy Loading
 * -------------------------------------------------------------------------------------------------
 * Lazy loading is a technique for delaying the loading of certain elements until they are needed,
 * which can help improve page load times.
 *
 * We use three functions used for lazy loading images and scripts in our theme:
 *
 *  - setImageSources function - copies the data-src and data-srcset attributes of lazy loaded
 *    images to their src and srcset attributes.
 *  - initLazyScript function - only loads a script when a specific element is scrolled into view.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 2) Cookies
 * -------------------------------------------------------------------------------------------------
 * Cookies are small pieces of data that can be stored on a user's computer. They can be useful for
 * tracking user activity, remembering user preferences or other similar purposes.
 *
 * We use three functions to manage cookies:
 *
 *  - setCookie function - sets a cookie with a given name, value and number of days until it
 *  should expire.
 *  - getCookie function - takes in the name of a cookie to retrieve its value.
 *  - deleteCookie function - takes in the name of a cookie to delete it.
 *
 *
 * -------------------------------------------------------------------------------------------------
 * 3) Media Queries
 * -------------------------------------------------------------------------------------------------
 * The theme creates a theme.mediaMatches object (in theme.liquid) for several key screen sizes
 * specified in our theme, and adds listeners for each media query.
 *
 * These are:
 *
 * mediaQueries: {
 *  sm: '(min-width: 600px)',
 *  md: '(min-width: 769px)',
 *  lg: '(min-width: 1024px)',
 *  xl: '(min-width: 1280px)',
 *  xxl: '(min-width: 1536px)',
 *  portrait: '(orientation: portrait)'
 * }
 *
 * If a breakpoint is crossed, the mediaMatches values are updated and an 'on:breakpoint-change'
 * event is dispatched.
 *
 * You can request the entire theme.mediaMatches object to check which media queries are currently
 * matched. In this case, the returned data will be an object with the names of the media queries as
 * keys, and boolean values indicating whether they are currently matched or not.
 *
 * Example:
 *
 * {
 *  sm: true,
 *  md: true,
 *  lg: true,
 *  xl: true,
 *  xxl: false,
 *  portrait: false
 * }
 *
 * You can reference a specific media query to check if it's currently matched by using:
 * theme.mediaMatches.lg.
 *
 * To check if you're on mobile you can use:
 * !theme.mediaMatches.md
 *
 * If you want to perform some action when the breakpoint changes, you can listen for the
 * breakpoint-change event on the window object.
 *
 * Example:
 * window.addEventListener('on:breakpoint-change', (event) => {
 *  // your code here
 * });
 *
 * =================================================================================================
 *
 * Have fun! - The Clean Canvas Development Team.
 */

// ---------------------------------------------------------------------------
// Province cart attribute — keeps #pv-province-attr hidden input in sync with
// the currently detected province so it is submitted natively with the cart form.
// The MutationObserver re-applies the value after every cart drawer re-render.
// ---------------------------------------------------------------------------
(function () {
  var _province = '';
  var _visitorContext = '';

  function sync() {
    var input = document.getElementById('pv-province-attr');
    if (input) input.value = _province;

    document.querySelectorAll('[name="attributes[_visitor_context]"]').forEach(function (el) {
      el.value = _visitorContext;
    });
  }

  function setProvince(province) {
    _province = province || '';
    sync();
  }

  function setVisitorContext(value) {
    _visitorContext = value || '';
    sync();
  }

  // Update when province is detected or manually changed.
  document.addEventListener('on:province:detected', function (e) {
    setProvince(e.detail && e.detail.province ? e.detail.province : document.body.dataset.province || '');
  });

  document.addEventListener('DOMContentLoaded', function () {
    // Seed province from body data attribute.
    setProvince(document.body.dataset.province || '');

    // Seed visitor context from localStorage (written by province-detection.js).
    try {
      var stored = localStorage.getItem('pv-visitor-context');
      if (stored) setVisitorContext(stored);
    } catch (e) {}

    // Re-sync after every cart drawer re-render (innerHTML replacement resets inputs to "").
    var cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer && window.MutationObserver) {
      new MutationObserver(sync).observe(cartDrawer, { childList: true, subtree: true });
    }
  });

  // Also re-sync when province-detection.js writes the context (fires after DOMContentLoaded).
  document.addEventListener('on:province:detected', function () {
    try {
      var stored = localStorage.getItem('pv-visitor-context');
      if (stored) setVisitorContext(stored);
    } catch (e) {}
  });
})();

window.updateCartSubtotalAttribute = async function(cartData, sectionsConfig = {}) {
  const EXCLUDED_VARIANT_ID = Number(window.theme?.settings?.shippingProtectionVariantId) || null;
  const subtotalCents = cartData.items.reduce((sum, item) => {
    if (item.variant_id === EXCLUDED_VARIANT_ID) return sum;
    if (item.properties?.['_market_tax'] === 'true') return sum;
    // if ('_tax_for' in (item.properties || {})) return sum;
    return sum + item.final_line_price;
  }, 0);

  const subtotalDollars = (subtotalCents / 100).toFixed(2);

  // await new Promise(resolve => setTimeout(resolve, 300));

  const requestBody = {
    attributes: { '_cart_subtotal_after_discounts': subtotalDollars }
  };

  if (sectionsConfig.sections) requestBody.sections = sectionsConfig.sections;
  if (sectionsConfig.sections_url) requestBody.sections_url = sectionsConfig.sections_url;

  const response = await fetch(theme.routes.cartUpdate, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(requestBody)
  });

  window.__pvLastSubtotalUpdate = Date.now();
  return response.json();
};
